import { render } from "./AnalyticsNotesForeignTradeTable.vue?vue&type=template&id=7ec872e4&scoped=true&ts=true"
import script from "./AnalyticsNotesForeignTradeTable.vue?vue&type=script&lang=ts"
export * from "./AnalyticsNotesForeignTradeTable.vue?vue&type=script&lang=ts"

import "./AnalyticsNotesForeignTradeTable.vue?vue&type=style&index=0&id=7ec872e4&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ec872e4"]])

export default __exports__